import React from "react";
import LoginRegister from "../../Component/LoginRegister/LoginRegister";
import Metas from "../../Component/Metas";

const Login = (props) => {
  return (
    <>
      <Metas title="ورود | لینگوتاک" description="ورود | لینگوتاک" />

      <LoginRegister {...props} />
    </>
  );
};

export default Login;
